import React from 'react'
import Chart from 'react-apexcharts'
import { RISK_REPORTS } from 'src/utils/constants/RiskReports'

const PieChart = ({ series, categories, height, colors, otherCategories }) => {
  const OTHER_CATEGORIES = otherCategories ?? []
  const options = {
    chart: {
      id: 'premium',
    },
    dataLabels: {
      textAnchor: 'middle',
      formatter: function (val, opts) {
        return opts.w.config.series[opts.seriesIndex]
      },
    },
    labels: categories,
    colors: colors,
    stroke: {
      width: 0,
    },
    legend: {
      show: true,
      position: 'bottom',
      style: {
        colors: '#333333',
        fontSize: '11px',
        fontWeight: 400,
      },
    },
    tooltip: {
      fixed: {
        enabled: true,
      },
      custom: function ({ seriesIndex, w }) {
        if (w.config.labels[seriesIndex] === 'Others') {
          const listItems = OTHER_CATEGORIES.map(
            (e) => '<span>' + e + '</span>'
          )
          const finalList = listItems.join(' ')
          return '<div class="tooltip-list">' + finalList + '</div>'
        }
        return (
          '<div class="tooltip-list">' +
          '<span>' +
          w.config.labels[seriesIndex] +
          '</span>' +
          '</div>'
        )
      },
    },
  }
  return (
    <>
      {series?.length > 0 ? (
        <Chart
          options={options}
          series={series}
          type={RISK_REPORTS?.PIE}
          height={height}
        />
      ) : (
        <p>Nil Claims</p>
      )}
    </>
  )
}

export default PieChart
